import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=128bc6f8&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=ts"
export * from "./Comment.vue?vue&type=script&lang=ts"
import style0 from "./Comment.vue?vue&type=style&index=0&id=128bc6f8&prod&scoped=true&lang=less"
import style1 from "./Comment.vue?vue&type=style&index=1&id=128bc6f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128bc6f8",
  null
  
)

export default component.exports